import { Routes, Route } from "react-router-dom";
import LandingPage from "../Pages/landing_page";
import WebinarPage from "../Pages/webinar";
import HydroponicMasterclass from "../Pages/hydroponicmasterclass";
import AboutKryzen from "../Components/Landing/about";
import Vacancies from "../Pages/vacancies";
import GalleryPage from "../Pages/gallery";
import SinglePost from "../Blog/single_blog";
import BlogList from "../Blog/blog_list";
import PageNotFound from "../Pages/page_not_found";
import CalenderPage from "../Pages/calender";
import EmailConfirmation from "../Pages/email_confirmation";

export default function AllRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/webinar" element={<WebinarPage />} />
      <Route path="/about" element={<AboutKryzen />} />
      <Route path="/vacancies" element={<Vacancies />} />
      <Route path="/gallery" element={<GalleryPage />} />
      <Route path="/news" element={<BlogList />} />
      <Route path="/news/:slug" element={<SinglePost />} />

      <Route
        path="/hydroponic-masterclass"
        element={<HydroponicMasterclass />}
      />
      <Route path="/hydroponic-upcoming-events" element={<CalenderPage />} />
      <Route
        path="/email-confirmation/:email"
        element={<EmailConfirmation />}
      />

      {/* Catch-All Route for 404 */}
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
}
